import React, { Component } from "react";

import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import { Button } from "@material-ui/core";

import "./Footer.css";
export default class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.links = [
      {
        name: "Home",
        link: "/",
      },
      {
        name: "Committee",
        link: "/committee/organizing-committee",
      },
      {
        name: "Registration",
        link: "/registration",
      },
      {
        name: "Contact",
        link: "/contact",
      },
      {
        name: "Privacy Policy",
        link: "/privacy-policy",
      },
    ];
  }

  navigateTo = (route) => {
    this.props.history.push(route);
  };
  render() {
    return (
      <footer className="footer-container" id="footer">
        {/* <div className="footer-bg"></div>  */}

        <div className="footer-content">
          <div className="logo-container">
            <div className="logo-wrapper">
              <img src="/hindilogo.png" alt="Sgpgi Logo" />
              <img src="/endo.png" alt="Endo Logo" />
              <img src="/sgpgi-bhp.png" alt="Breast Course 2026" />
              <img src="/iaes-logo.png" alt="IAES-logo" />
            </div>
            {/* <div className="socials-icon">
              <a target="_blank" rel="noopener noreferrer" href="https://x.com/cardicon_2026?s=11">
                <img src="/x.svg" alt="x" />
              </a>
              <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/share/14Pg7P3L8Wf/?mibextid=wwXIfr">
                <FacebookIcon fontSize="large" style={{ color: "white" }} />
              </a>
              <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/cardicon2026">
                <InstagramIcon fontSize="large" style={{ color: "white" }} />
              </a>
            </div> */}
            <br />
            <div style={{ color: "var(--primeText)" }}>
              <h4>GST Details</h4>
              <p>
                <b>Legal Name: </b>
                <br />
                SGPGI ENDOCRINE AND BREAST SURGERY CME GROUP
                <br />
                <b>GST No: </b>
                <br />
                09ACCAS5467J1ZW
                <br />
                <b>Address:</b>
                <br />
                Fortune Select - Member ITC hotels. Cf 1, <br />
                Sector I, Lda Colony, Ashiyana, Lucknow
              </p>
            </div>
          </div>
          <div className="links-container">
            <h3>Important Links</h3>
            <div className="links">
              {this.links.map((link, index) => (
                <a key={index} href={link.link}>
                  <ArrowForwardIosIcon fontSize="small" />
                  {link.name}
                </a>
              ))}
            </div>
          </div>
          <div className="links-container">
            <h3>Contact Us</h3>
            <div className="footer-contact-prime">For any queries , call us at:</div>

            <div className="footer-contact-prime">
              <b>Mobile:</b>
              <span className="line"> +91-522-2494409,</span>
              <span className="line"> +91-8470061591</span>
            </div>

            <div className="footer-contact-prime">
              <b>Secretariat Address:</b>
              <span className="line"> Department of Endocrine & Breast </span>
              <span className="line"> Surgery, C-Block, SGPGIMS, Raebareli </span>
              <span className="line"> Road, Lucknow - 226014</span>
            </div>

            <div className="footer-contact-prime">
              <Button variant="contained" color="primary" className="footer-contact-btn" onClick={() => this.navigateTo("/contact")}>
                Submit Query
              </Button>
            </div>
          </div>
          <div className="links-container">
            <h3>PCO</h3>

            <img src="/cem.jpg" alt="pco" className="pco-img" style={{ width: "100%", height: "auto" }} />

            <h4 className="footer-contact">CEM Hospitality</h4>
            <div className="footer-contact">
              <b>Pawandeep Anand:</b> 7800902120
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
